import { ListItem, ListItemText, Typography } from '@material-ui/core';
import { KeyboardArrowRight } from '@material-ui/icons';
import { ColorDynamic } from '@superdispatch/ui';
import { trackLoadboardEvent } from '../../core/LoadboardAnalytics';
import { SavedSearchTitle } from '../../core/saved-searches/SavedSearchHelpers';
import { PostingSavedSearchDTO } from '../../data/dto/PostingSavedSearchDTO';
import { useLoadboardContext } from '../../data/LoadboardContext';

interface HomeScreenSavedSearchListItemProps {
  savedSearch: PostingSavedSearchDTO;
}

export function HomeScreenSavedSearchListItem({
  savedSearch,
}: HomeScreenSavedSearchListItemProps) {
  const {
    router: { openSavedSearchScreen },
  } = useLoadboardContext();
  return (
    <ListItem
      key={savedSearch.guid}
      divider={true}
      button={true}
      onClick={() => {
        trackLoadboardEvent({ name: 'SLB: Clicked Load Alert', savedSearch });
        openSavedSearchScreen({ savedSearch, source: 'Load Alert' });
      }}
    >
      <ListItemText>
        <Typography noWrap={true}>
          <SavedSearchTitle savedSearch={savedSearch} />
        </Typography>
      </ListItemText>

      <KeyboardArrowRight fontSize="small" htmlColor={ColorDynamic.Dark100} />
    </ListItem>
  );
}
